module.exports = __webpack_public_path__ + "media/styles/images/svg/filter-white-9ac35df967e8372fb740aee464802290.svg";